import React, { useEffect, useRef, useState } from 'react';

export default function AnularVentaModal({
  abierto,
  venta,
  procesando,
  onClose,
  onConfirm,
}) {
  const pinRef = useRef(null);

  const [pin, setPin] = useState('');
  const [motivo, setMotivo] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!abierto) return;

    setPin('');
    setMotivo('');
    setError('');

    requestAnimationFrame(() => {
      pinRef.current?.focus();
    });
  }, [abierto, venta?.id]);

  if (!abierto || !venta) return null;

  const confirmar = async (event) => {
    event.preventDefault();

    if (procesando) return;

    if (!pin.trim()) {
      setError('Ingresá el PIN de administrador.');
      pinRef.current?.focus();
      return;
    }

    if (!motivo.trim()) {
      setError('Indicá el motivo de la anulación.');
      return;
    }

    try {
      setError('');

      // El backend valida el PIN y exige rol administrador.
      const resultado = await onConfirm({
        ventaId: venta.id,
        autorizacionPin: pin.trim(),
        motivo: motivo.trim(),
      });

      if (!resultado?.ok) {
        setError(
          resultado?.error ||
            'No se pudo anular la venta.'
        );
        setPin('');
        pinRef.current?.focus();
      }
    } catch (err) {
      console.error(
        'Error anulando venta Cantina:',
        err
      );

      setError(
        err?.response?.data?.error ||
          err?.message ||
          'No se pudo anular la venta.'
      );
    }
  };

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center bg-azul-oscuro/85 p-4 backdrop-blur-sm">
      <form
        onSubmit={confirmar}
        className="w-full max-w-lg overflow-hidden rounded-3xl border border-blanco-puro/20 bg-azul-oscuro shadow-2xl"
      >
        <div className="border-b border-blanco-puro/10 px-6 py-5">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-red-300">
            Operación sensible
          </div>

          <h2 className="mt-1 text-2xl font-black text-blanco-puro">
            Anular venta #{venta.id}
          </h2>

          <p className="mt-2 text-sm leading-6 text-blanco-puro/60">
            La venta quedará registrada como anulada y los
            productos serán devueltos automáticamente al stock.
          </p>
        </div>

        <div className="space-y-5 p-6">
          <label className="block">
            <span className="mb-1.5 block text-xs font-bold uppercase tracking-wide text-blanco-puro/60">
              Motivo
            </span>

            <textarea
              value={motivo}
              onChange={(event) =>
                setMotivo(event.target.value)
              }
              disabled={procesando}
              rows={3}
              maxLength={255}
              placeholder="Ej: Venta cargada por error"
              className="w-full resize-none rounded-xl border border-blanco-puro/20 bg-azul-oscuro/70 px-4 py-3 text-sm text-blanco-puro placeholder:text-blanco-puro/40 outline-none transition focus:border-amarillo-dorado focus:ring-2 focus:ring-amarillo-dorado/30 disabled:opacity-50"
            />
          </label>

          <label className="block">
            <span className="mb-1.5 block text-xs font-bold uppercase tracking-wide text-blanco-puro/60">
              PIN de administrador
            </span>

            <input
              ref={pinRef}
              name="cantina-anulacion-pin"
              type="password"
              inputMode="numeric"
              autoComplete="one-time-code"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck={false}
              data-lpignore="true"
              data-1p-ignore="true"
              value={pin}
              onChange={(event) =>
                setPin(event.target.value)
              }
              disabled={procesando}
              className="h-12 w-full rounded-xl border border-blanco-puro/20 bg-azul-oscuro/70 px-4 text-center text-xl font-bold tracking-[0.35em] text-blanco-puro outline-none transition focus:border-amarillo-dorado focus:ring-2 focus:ring-amarillo-dorado/30 disabled:opacity-50"
            />
          </label>

          {error && (
            <div className="rounded-xl border border-red-400/30 bg-red-500/10 px-4 py-3 text-sm font-semibold text-red-100">
              {error}
            </div>
          )}

          <div className="rounded-xl border border-amarillo-dorado/20 bg-amarillo-dorado/10 px-4 py-3 text-xs leading-5 text-blanco-puro/70">
            Esta operación no elimina la venta. Quedará
            conservada en el historial para mantener la
            trazabilidad.
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={procesando}
              className="rounded-xl border border-blanco-puro/20 px-5 py-2.5 text-sm font-bold text-blanco-puro transition hover:bg-blanco-puro/10 disabled:opacity-50"
            >
              Cancelar
            </button>

            <button
              type="submit"
              disabled={procesando}
              className="rounded-xl bg-red-500 px-5 py-2.5 text-sm font-bold text-white transition hover:bg-red-600 disabled:opacity-50"
            >
              {procesando
                ? 'Anulando...'
                : 'Confirmar anulación'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
